import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EntityType } from "../../common/enum";
import * as API from "../../utils/apis";
import { donationSlice } from "../DonationView/slice";
import { saveEntityProfileSelectedToIndexedDB , removeFromIndexedDB} from "../../storage/profileStorage";
const getMyProducts = (id, list) => {
  return list.filter((product) => product.donationId === id);
};
export const getMyActiveDonation = createAsyncThunk(
  "DonationCart/getMyActiveDonation", // TODO: replace with myActiveDonations
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = "Donation/GetDonations";
      const params = {
        ...data,
      };
      const res = await API.getApi(url, params, token);
      
      if(data.entityType == "SPECIAL_DISTRIBUTOR" && data.isDonationAvailble == true || data.entityType == "SPECIAL_DISTRIBUTOR" && data.isDonationAvailble == undefined){
        const countExpiredDate = res.data.obj.result.countExpiredDate;
        //const dayExpiryCount = res.data.obj.resultdayExpiryCount;
        const totalCount = res.data.obj.result.totalCount;
        const donationDetails = res.data.obj.result.donationDetails;

        const currentDateTime = new Date();
        const activeDonations = donationDetails.filter((donation) => {
          const expiryDateTime = new Date(donation.donation.expiryDate);
          return expiryDateTime <= currentDateTime;
        });
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); 

        const dayExpiryCount = activeDonations.filter((donation) => {
          const consumeByDate = new Date(donation.donation.consumeByDate);
          consumeByDate.setHours(0, 0, 0, 0); 

          return consumeByDate.getTime() === currentDate.getTime();
        });

        var arrayDisponiveis = {countExpiredDate : dayExpiryCount.length ,dayExpiryCount: dayExpiryCount.length ,  donationDetails: activeDonations , totalCount:activeDonations.length}
        return arrayDisponiveis;
      }else if(data.entityType == "SPECIAL_DISTRIBUTOR" && data.isDonationAvailble == false){
        const countExpiredDate = res.data.obj.result.countExpiredDate;
        // const dayExpiryCount = res.data.obj.result.dayExpiryCount;
        const totalCount = res.data.obj.result.totalCount;
        const donationDetails = res.data.obj.result.donationDetails;

        const currentDateTime = new Date();
        const activeDonations = donationDetails.filter((donation) => {
          const expiryDateTime = new Date(donation.donation.expiryDate);
          return expiryDateTime >= currentDateTime;
        });
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); 

        const dayExpiryCount = activeDonations.filter((donation) => {
          const consumeByDate = new Date(donation.donation.consumeByDate);
          consumeByDate.setHours(0, 0, 0, 0); 

          return consumeByDate.getTime() === currentDate.getTime();
        });

        var arrayDisponiveis = {countExpiredDate : dayExpiryCount.length ,dayExpiryCount: dayExpiryCount.length ,  donationDetails: activeDonations , totalCount:activeDonations.length}
        return arrayDisponiveis;
      }else{
        return res.data.obj.result;
      }
      
    } catch (error) {
      // rejectWithValue(error.response.data);t
      //throw error;
    }
  }
);

export const fetchUnreadCount = createAsyncThunk(
  "Notification/unreadcount", // TODO: replace with myActiveDonations
  async (entityId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Notification/unreadcount/${entityId}`;
      const res = await API.getApi(url, {}, token);
      return res;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const markasread = createAsyncThunk(
  "Notification/markasread",
  async (notificationId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        `Notification/markasread/${notificationId}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const markasallread = createAsyncThunk(
  "Notification/markasallread",
  async (userId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        `Notification/markasallread/${userId}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const SendNotification = createAsyncThunk(
  "Notification/SendNotification",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        "Notification/SendNotification",
        data,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const fetchUnread = createAsyncThunk(
  "Notification/unread", // TODO: replace with myActiveDonations
  async (entityId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Notification/unread/${entityId}`;
      const res = await API.getApi(url, {}, token);
      return res;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const fetchAllNotifications = createAsyncThunk(
  "Notification/all", // TODO: replace with myActiveDonations
  async (entityId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Notification/all/${entityId}`;
      const res = await API.getApi(url, {}, token);
      return res;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const getCancelCollectionDonationById = createAsyncThunk(
  "DonationCart/getCancelCollectionDonationById", // TODO: replace with myActiveDonations
  async (donationId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Donation/GetDonationById/${donationId}`;
      const res = await API.getApi(url, {}, token);
      return res.data.donationId;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const GetEventProduct = createAsyncThunk(
  "DonationCart/GetEventProduct",
  async (donationId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Donation/GetEventProduct/${donationId}`;
      const res = await API.getApi(url, {}, token);
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const getParticularDonationById = createAsyncThunk(
  "DonationCart/getParticularDonationById", // TODO: replace with myActiveDonations
  async (donationId, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Donation/GetDonationById/${donationId}`;
      const res = await API.getApi(url, {}, token);
      return res.data.donationId;
    } catch (error) {
      // rejectWithValue(error.response.data);t
      console.error(error);
      throw error;
    }
  }
);

export const getDonationProduct = createAsyncThunk(
  "DonationCart/getDonationProduct",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();

      const res = await API.getDataApi("Donation/GetProductList", token);

      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      console.error(error);
      throw error;
    }
  }
);

export const getRating = createAsyncThunk(
  "DonationCart/getRating",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const params = {
        ...data,
      };
      const res = await API.getApi("Donation/getRating", params, token);
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getDonationBySearchKey = createAsyncThunk(
  "DonationCart/getDonationBySearchKey", // TODO: replace with myActiveDonations
  async (values, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const url = `Donation/getDonationBySearchKey/${values.donationId}/${values.userType}/${values.entityId}`;
      const res = await API.getApi(url, {}, token);
      return res.data;
    } catch (error) {
     
    }
  }
);

const initialState = {
  loading: false,
  myActiveDonations: [],
  myActiveDonationsTotalCount: 0,
  myActiveDonationsOffSet: 0,
  myActiveDonationsLimit: 10,
  myActiveDonationsPage: 1,
  notifications: [],
  tileData: [],
  dashboardTab: "",
  status: "idle",
  selectedDonation: {},
  particularDonationById: {},
  cancelCollectionDonation: {},
  selectCollectionDate: null,
  dayExpiryDonationsCount: 0,
  CountExpiredDate: 0,
  entityProfileSelect: "",
  rating: {},
};
export const dashboardSlice = createSlice({
  name: "dashboardInfo",
  initialState,
  reducers: {
    resetDashBoard: (state) => {
      // state = initialState;
      return { ...initialState };
    },
    setDashboardTab: (state, action) => {
      state.dashboardTab = action.payload;
    },
    setTileData: (state, action) => {
      state.tileData = action.payload;
    },
    setSelectedDonation: (state, action) => {
      state.selectedDonation = action.payload;
    },
    setMyActiveDonationsOffset: (state, action) => {
      state.myActiveDonationsOffSet = action.payload;
    },
    setMyActiveDonationsLimit: (state, action) => {
      state.myActiveDonationsLimit = action.payload;
    },
    clearMyActiveDonations: (state) => {
      state.myActiveDonations = [];
      state.myActiveDonationsTotalCount = 0;
      state.myActiveDonationsPage = 1;
    },
    setMyActiveDonationsPage: (state, action) => {
      state.myActiveDonationsPage = action.payload;
    },
    setSelectCollectionDate: (state, action) => {
      state.selectCollectionDate = action.payload;
    },
    setEntityProfileSelect: (state, action) => {
      state.entityProfileSelect = action.payload;
      removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
      saveEntityProfileSelectedToIndexedDB(action.payload)
      localStorage.setItem("entityProfileSelect",JSON.stringify(action.payload))
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyActiveDonation.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      // .addCase(getMyActiveDonation.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   state.loading = false;
      //   const donations = action.payload;

      //   if (!donations) {
      //     // Lidar com o caso em que `donations` ou `donations.donationDetails` são null/undefined
      //     state.selectedDonation = null;
      //     state.myActiveDonations = [];
      //     state.myActiveDonationsTotalCount = 0;
      //     state.dayExpiryDonationsCount = 0;
      //     state.CountExpiredDate = 0;
      // } else {
      //     // Caso os dados sejam válidos
      //     state.selectedDonation = donations.donationDetails[0];
      //     state.myActiveDonations = donations.donationDetails;
      //     state.myActiveDonationsTotalCount = donations.totalCount || 0;
      //     state.dayExpiryDonationsCount = donations.dayExpiryCount || 0;
      //     state.CountExpiredDate = donations.countExpiredDate || 0;
      // }
      // })
      .addCase(getMyActiveDonation.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;

        const donations = action.payload;

        if (!donations || !donations.donationDetails || donations.donationDetails.length === 0) {
          state.selectedDonation = null;
          state.myActiveDonations = [];
          state.myActiveDonationsTotalCount = 0;
          state.dayExpiryDonationsCount = 0;
          state.CountExpiredDate = 0;
        } else {
          state.selectedDonation = donations.donationDetails[0] || null;
          state.myActiveDonations = donations.donationDetails || [];
          state.myActiveDonationsTotalCount = donations.totalCount || 0;
          state.dayExpiryDonationsCount = donations.dayExpiryCount || 0;
          state.CountExpiredDate = donations.countExpiredDate || 0;
        }
      })
      .addCase(getMyActiveDonation.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.myActiveDonations = [];
        state.myActiveDonationsTotalCount = 0;
        state.myActiveDonationsOffSet = 0;
        state.myActiveDonationsLimit = 10;
        state.myActiveDonationsPage = 1;
      })
      .addCase(getParticularDonationById.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getParticularDonationById.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.particularDonationById = donations;
      })
      .addCase(getParticularDonationById.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.particularDonationById = {};
      })
      .addCase(getCancelCollectionDonationById.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getCancelCollectionDonationById.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(getCancelCollectionDonationById.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(markasread.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(markasread.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(markasread.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(markasallread.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(markasallread.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(markasallread.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(SendNotification.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(SendNotification.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(SendNotification.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(fetchUnreadCount.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(fetchUnreadCount.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(fetchAllNotifications.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(fetchAllNotifications.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(fetchAllNotifications.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(fetchUnread.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(fetchUnread.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(fetchUnread.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(GetEventProduct.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(GetEventProduct.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload;
        state.cancelCollectionDonation = donations;
      })
      .addCase(GetEventProduct.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.cancelCollectionDonation = {};
      })
      .addCase(getRating.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getRating.fulfilled, (state, action) => {
        state.status = "idle";
        state.rating = action.payload;
      })
      .addCase(getRating.rejected, (state, action) => {
        state.status = "idle";
        state.rating = {};
      })
      .addCase(getDonationBySearchKey.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getDonationBySearchKey.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const donations = action.payload && action.payload.donationId && action.payload.donationId.donations ? [action.payload.donationId.donations]:[];
        state.selectedDonation = donations && donations.length ? donations[0] :{};
        state.myActiveDonations = donations&& donations.length ? donations :[];
        state.myActiveDonationsTotalCount = 1;
        state.dayExpiryDonationsCount = 0;
        state.CountExpiredDate = 0
      })
      .addCase(getDonationBySearchKey.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.myActiveDonations = [];
        state.myActiveDonationsTotalCount = 0;
        state.myActiveDonationsOffSet = 0;
        state.myActiveDonationsLimit = 10;
        state.myActiveDonationsPage = 1;
      })
  },
});

export const {
  resetDashBoard,
  setDashboardTab,
  setTileData,
  setSelectedDonation,
  setMyActiveDonationsOffset,
  setMyActiveDonationsLimit,
  clearMyActiveDonations,
  setMyActiveDonationsPage,
  setSelectCollectionDate,
  setEntityProfileSelect,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
